import BottomNavigation from "@material-ui/core/BottomNavigation";
import BottomNavigationAction from "@material-ui/core/BottomNavigationAction";
import AttachMoney from "@material-ui/icons/AttachMoney";
import Description from "@material-ui/icons/Description";
import Help from "@material-ui/icons/Help";
import HomeIcon from "@material-ui/icons/Home";
import LocalAtmSharpIcon from "@material-ui/icons/LocalAtmSharp";
import People from "@material-ui/icons/People";
import ReceiptIcon from "@material-ui/icons/Receipt";
import MenuBookIcon from "@material-ui/icons/MenuBook";
import React from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import * as actions from "../actions";
import UnavailableFeatureTooltip from "./UnavailableFeatureTooltip";
import { Roles, ListRoutes, getActualRole } from "../util";
import { FormattedMessage } from "react-intl";

const CustomerAptNavigation = ({ value, onChange }) => (
  <BottomNavigation value={value} onChange={onChange} showLabels style={{ zIndex: 200 }}>
    <BottomNavigationAction label={<FormattedMessage id="app.navigationBar.home" />} component={Link} to="/dashboard" icon={<HomeIcon />} />
    <BottomNavigationAction label={<FormattedMessage id="app.navigationBar.contracts" />} component={Link} to="/contracts" icon={<Description />} />
    <BottomNavigationAction label={<FormattedMessage id="app.navigationBar.hire" />} component={Link} to="/newContact" icon={<AttachMoney />} />
    <BottomNavigationAction label={<FormattedMessage id="app.navigationBar.account" />} component={Link} to="/history" icon={<ReceiptIcon />} />
    <BottomNavigationAction label={<FormattedMessage id="app.navigationBar.help" />} component={Link} to="/help" icon={<Help />} />
  </BottomNavigation>
);

const UnavailableCustomerNavigationAction = ({ label, icon, tooltipValue, blockedTooltipValue, onMouseEnter, onMouseLeave, onClick, ...props }) => (
  <BottomNavigationAction
    {...props}
    value={tooltipValue}
    label={<FormattedMessage id={label} />}
    onMouseEnter={() => onMouseEnter(tooltipValue)}
    onMouseLeave={onMouseLeave}
    onClick={(event) => onClick(event, tooltipValue)}
    icon={
      <UnavailableFeatureTooltip
        unavailable
        forceOpen={blockedTooltipValue === tooltipValue}
        title={<FormattedMessage id="app.completeRegistrationToAccess" />}
        placement="top"
        arrow
        enterTouchDelay={100}
        leaveTouchDelay={2500}
        spanStyle={{ display: "inline-flex" }}
      >
        {icon}
      </UnavailableFeatureTooltip>
    }
  />
);

const CustomerInaptNavigation = ({ value }) => {
  const [blockedTooltipValue, setBlockedTooltipValue] = React.useState(null);

  const handleUnavailableNavigationClick = (event, tooltipValue) => {
    event.preventDefault();
    event.stopPropagation();
    setBlockedTooltipValue(tooltipValue);
  };

  const handleUnavailableNavigationMouseEnter = (tooltipValue) => {
    setBlockedTooltipValue(tooltipValue);
  };

  const handleUnavailableNavigationMouseLeave = () => {
    setBlockedTooltipValue(null);
  };

  return (
    <BottomNavigation value={value} onChange={() => {}} showLabels style={{ zIndex: 200 }}>
      <BottomNavigationAction value={0} label={<FormattedMessage id="app.navigationBar.home" />} component={Link} to="/dashboard" icon={<HomeIcon />} />
      <UnavailableCustomerNavigationAction
        label="app.navigationBar.contracts"
        icon={<Description />}
        tooltipValue="contracts"
        blockedTooltipValue={blockedTooltipValue}
        onMouseEnter={handleUnavailableNavigationMouseEnter}
        onMouseLeave={handleUnavailableNavigationMouseLeave}
        onClick={handleUnavailableNavigationClick}
      />
      <UnavailableCustomerNavigationAction
        label="app.navigationBar.hire"
        icon={<AttachMoney />}
        tooltipValue="hire"
        blockedTooltipValue={blockedTooltipValue}
        onMouseEnter={handleUnavailableNavigationMouseEnter}
        onMouseLeave={handleUnavailableNavigationMouseLeave}
        onClick={handleUnavailableNavigationClick}
      />
      <UnavailableCustomerNavigationAction
        label="app.navigationBar.account"
        icon={<ReceiptIcon />}
        tooltipValue="account"
        blockedTooltipValue={blockedTooltipValue}
        onMouseEnter={handleUnavailableNavigationMouseEnter}
        onMouseLeave={handleUnavailableNavigationMouseLeave}
        onClick={handleUnavailableNavigationClick}
      />
      <BottomNavigationAction value={4} label={<FormattedMessage id="app.navigationBar.help" />} component={Link} to="/help" icon={<Help />} />
    </BottomNavigation>
  );
};

class SimpleBottomNavigation extends React.Component {
  routes = [];

  state = {
    value: 0,
  };

  constructor(props) {
    super(props);

    switch (getActualRole(this.props.currentUser)) {
      case Roles.Admin:
        this.routes = ListRoutes.Admin;
        break;
      case Roles.Agent:
        this.routes = ListRoutes.Agent;
        break;
      case Roles.AgentsManager:
        this.routes = ListRoutes.AgentsManager;
        break;
      case Roles.BusinessManager:
        this.routes = ListRoutes.BusinessManager;
        break;
      case Roles.Customer:
        this.routes = ListRoutes.Customer;
        break;
      case Roles.FinanceManager:
        this.routes = ListRoutes.FinanceManager;
        break;
      case Roles.Kyc:
        this.routes = ListRoutes.Kyc;
        break;
      case Roles.Auditor:
        this.routes = ListRoutes.Auditor;
        break;
      default:
        this.routes = ListRoutes.Customer;
    }
  }

  componentDidMount() {
    this.selectByRoute();
  }

  componentDidUpdate(oldProps, prevState) {
    this.selectByRoute(prevState);
  }

  handleChange = (event, value) => {
    this.setState({ value });
  };

  selectByRoute = (prevState) => {
    const { history } = this.props;
    const route = this.routes.find((r) => history.location.pathname.startsWith(r.path));
    const routeId = route ? route.id : 0;
    if (prevState && prevState.value == routeId) return;
    this.setState({ value: routeId });
  };

  render() {
    const { currentUser } = this.props;
    const { value } = this.state;
    const currentUserRole = getActualRole(currentUser);

    return currentUserRole == Roles.Agent ? (
      <BottomNavigation value={value} onChange={this.handleChange} showLabels style={{ zIndex: 200 }}>
        <BottomNavigationAction label={<FormattedMessage id="app.navigationBar.home" />} component={Link} to="/dashboard" icon={<HomeIcon />} />
        <BottomNavigationAction label={<FormattedMessage id="app.navigationBar.contracts" />} component={Link} to="/contracts" icon={<Description />} />
        <BottomNavigationAction label={<FormattedMessage id="app.navigationBar.management" />} component={Link} to="/customer-management" icon={<People />} />
        {/* <BottomNavigationAction label={<FormattedMessage id="app.navigationBar.users" />} component={Link} to="/customers" icon={<People />} /> */}
        <BottomNavigationAction label={<FormattedMessage id="app.navigationBar.account" />} component={Link} to="/history" icon={<ReceiptIcon />} />
        <BottomNavigationAction label={<FormattedMessage id="app.navigationBar.help" />} component={Link} to="/help" icon={<Help />} />
      </BottomNavigation>
    ) : currentUserRole == Roles.AgentsManager ? (
      <BottomNavigation value={value} onChange={this.handleChange} showLabels style={{ zIndex: 200 }}>
        <BottomNavigationAction label={<FormattedMessage id="app.navigationBar.home" />} component={Link} to="/dashboard" icon={<HomeIcon />} />
        <BottomNavigationAction label={<FormattedMessage id="app.navigationBar.contracts" />} component={Link} to="/contracts" icon={<Description />} />
        <BottomNavigationAction label={<FormattedMessage id="app.navigationBar.management" />} component={Link} to="/management" icon={<People />} />
        {/* <BottomNavigationAction label={<FormattedMessage id="app.navigationBar.users" />} component={Link} to="/customers" icon={<People />} /> */}
        <BottomNavigationAction label={<FormattedMessage id="app.navigationBar.account" />} component={Link} to="/history" icon={<ReceiptIcon />} />
        {/* <BottomNavigationAction label={<FormattedMessage id="app.reports" />} component={Link} to="/reports" icon={<MenuBookIcon />} /> */}
        <BottomNavigationAction label={<FormattedMessage id="app.navigationBar.help" />} component={Link} to="/help" icon={<Help />} />
      </BottomNavigation>
    ) : currentUserRole == Roles.Admin ? (
      <BottomNavigation value={value} onChange={this.handleChange} showLabels style={{ zIndex: 200 }}>
        <BottomNavigationAction label={<FormattedMessage id="app.navigationBar.home" />} component={Link} to="/dashboard" icon={<HomeIcon />} />
        <BottomNavigationAction label={<FormattedMessage id="app.withdrawals" />} component={Link} to="/history-withdrawal" icon={<LocalAtmSharpIcon />} />
        <BottomNavigationAction label={<FormattedMessage id="app.navigationBar.users" />} component={Link} to="/users" icon={<People />} />
        <BottomNavigationAction label={<FormattedMessage id="app.navigationBar.account" />} component={Link} to="/history" icon={<ReceiptIcon />} />
        <BottomNavigationAction label={<FormattedMessage id="app.reports" />} component={Link} to="/reports" icon={<MenuBookIcon />} />
      </BottomNavigation>
    ) : currentUserRole == Roles.Auditor ? (
      <BottomNavigation value={value} onChange={this.handleChange} showLabels style={{ zIndex: 200 }}>
        <BottomNavigationAction label={<FormattedMessage id="app.navigationBar.home" />} component={Link} to="/dashboard" icon={<HomeIcon />} />
        <BottomNavigationAction label={<FormattedMessage id="app.reports" />} component={Link} to="/reports" icon={<MenuBookIcon />} />
      </BottomNavigation>
    ) : currentUserRole == Roles.Customer ? (
      currentUser.apt ? (
        <CustomerAptNavigation value={value} onChange={this.handleChange} />
      ) : (
        <CustomerInaptNavigation value={value} />
      )
    ) : currentUserRole == Roles.FinanceManager ? (
      <BottomNavigation value={value} onChange={this.handleChange} showLabels style={{ zIndex: 200 }}>
        <BottomNavigationAction label={<FormattedMessage id="app.navigationBar.home" />} component={Link} to="/dashboard" icon={<HomeIcon />} />
        <BottomNavigationAction label={<FormattedMessage id="app.withdrawals" />} component={Link} to="/history-withdrawal" icon={<LocalAtmSharpIcon />} />
        <BottomNavigationAction label={<FormattedMessage id="app.navigationBar.users" />} component={Link} to="/users" icon={<People />} />
        <BottomNavigationAction label={<FormattedMessage id="app.reports" />} component={Link} to="/reports" icon={<MenuBookIcon />} />
      </BottomNavigation>
    ) : currentUserRole == Roles.BusinessManager ? (
      <BottomNavigation value={value} onChange={this.handleChange} showLabels style={{ zIndex: 200 }}>
        <BottomNavigationAction label={<FormattedMessage id="app.navigationBar.home" />} component={Link} to="/dashboard" icon={<HomeIcon />} />
        <BottomNavigationAction label={<FormattedMessage id="app.reports" />} component={Link} to="/reports" icon={<MenuBookIcon />} />
      </BottomNavigation>
    ) : currentUserRole == Roles.Kyc ? (
      <BottomNavigation value={value} onChange={this.handleChange} showLabels style={{ zIndex: 200 }}>
        <BottomNavigationAction label={<FormattedMessage id="app.navigationBar.home" />} component={Link} to="/dashboard" icon={<HomeIcon />} />
        <BottomNavigationAction label={<FormattedMessage id="app.navigationBar.users" />} component={Link} to="/users" icon={<People />} />
      </BottomNavigation>
    ) : (
      <BottomNavigation value={value} onChange={this.handleChange} showLabels style={{ zIndex: 200 }}>
        <BottomNavigationAction label={<FormattedMessage id="app.navigationBar.home" />} component={Link} to="/dashboard" icon={<HomeIcon />} />
      </BottomNavigation>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentUser: state.user.user.me,
  };
}

export default withRouter(connect(mapStateToProps, actions)(SimpleBottomNavigation));
